import { render, staticRenderFns } from "./Employment.vue?vue&type=template&id=71ac126f&scoped=true&lang=pug&"
import script from "./Employment.vue?vue&type=script&lang=ts&"
export * from "./Employment.vue?vue&type=script&lang=ts&"
import style0 from "./Employment.vue?vue&type=style&index=0&id=71ac126f&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ac126f",
  null
  
)

component.options.__file = "Employment.vue"
export default component.exports